import React from "react";

import style, { keyframes } from "styled-components";

const animation = keyframes`
    0%{
        transform: rotate(0deg);
    }
    25%{
        transform: rotate(90deg);
    }
    50%{
        transform: rotate(180deg);
    }
    75%{
        transform: rotate(270deg);
    }
    100%{
        transform: rotate(360deg);
    }
`;

const OuterDiv = style.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  animation ${animation} 1s linear infinite;
`;

type AllSizes = 20 | 24 | 32 | 40;

interface LoaderProps {
  width: AllSizes;
}

const Loader: React.FC<LoaderProps> = ({ width }) => {
  return (
    <OuterDiv>
      {width === 40 ? (
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5 2.5C22.8638 2.5 25.2044 2.96558 27.3883 3.87017C29.5722 4.77475 31.5565 6.10062 33.2279 7.77208C34.8994 9.44353 36.2252 11.4278 37.1298 13.6117C38.0344 15.7956 38.5 18.1362 38.5 20.5C38.5 22.8638 38.0344 25.2044 37.1298 27.3883C36.2252 29.5722 34.8994 31.5565 33.2279 33.2279C31.5565 34.8994 29.5722 36.2252 27.3883 37.1298C25.2044 38.0344 22.8638 38.5 20.5 38.5C18.1362 38.5 15.7956 38.0344 13.6117 37.1298C11.4278 36.2252 9.44353 34.8994 7.77207 33.2279C6.10062 31.5565 4.77475 29.5722 3.87017 27.3883C2.96558 25.2044 2.5 22.8638 2.5 20.5C2.5 18.1362 2.96559 15.7955 3.87017 13.6117C4.77476 11.4278 6.10063 9.44352 7.77209 7.77207C9.44354 6.10062 11.4278 4.77475 13.6117 3.87016C15.7956 2.96558 18.1362 2.5 20.5 2.5L20.5 2.5Z"
            stroke="#D1D5DB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.5 2.5C23.8196 2.5 27.0745 3.41799 29.905 5.15248C32.7354 6.88696 35.031 9.37038 36.5381 12.3282C38.0452 15.286 38.705 18.6029 38.4445 21.9123C38.1841 25.2216 37.0135 28.3945 35.0623 31.0801C33.1111 33.7657 30.4552 35.8595 27.3883 37.1298C24.3214 38.4002 20.9629 38.7977 17.6842 38.2784C14.4054 37.7591 11.3342 36.3432 8.80994 34.1873C6.28569 32.0314 4.4068 29.2194 3.38098 26.0623"
            stroke="#FF5943"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : width === 32 ? (
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5001 2.1001C18.3911 2.1001 20.2637 2.47256 22.0107 3.19623C23.7578 3.9199 25.3453 4.9806 26.6824 6.31776C28.0196 7.65492 29.0803 9.24237 29.804 10.9895C30.5276 12.7365 30.9001 14.6091 30.9001 16.5001C30.9001 18.3911 30.5276 20.2637 29.804 22.0107C29.0803 23.7578 28.0196 25.3453 26.6824 26.6824C25.3453 28.0196 23.7578 29.0803 22.0107 29.804C20.2636 30.5276 18.3911 30.9001 16.5001 30.9001C14.6091 30.9001 12.7365 30.5276 10.9895 29.804C9.24236 29.0803 7.65492 28.0196 6.31776 26.6824C4.98059 25.3453 3.9199 23.7578 3.19623 22.0107C2.47256 20.2636 2.1001 18.3911 2.1001 16.5001C2.1001 14.6091 2.47257 12.7365 3.19624 10.9894C3.9199 9.24236 4.9806 7.65492 6.31777 6.31775C7.65493 4.98059 9.24238 3.9199 10.9895 3.19623C12.7366 2.47256 14.6091 2.1001 16.5001 2.1001L16.5001 2.1001Z"
            stroke="#D1D5DB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.5001 2.1001C19.1558 2.1001 21.7597 2.83449 24.0241 4.22208C26.2884 5.60967 28.1249 7.5964 29.3306 9.96263C30.5362 12.3289 31.0641 14.9824 30.8557 17.6299C30.6473 20.2774 29.7109 22.8157 28.1499 24.9642C26.589 27.1127 24.4643 28.7877 22.0107 29.804C19.5572 30.8202 16.8704 31.1382 14.2474 30.7228C11.6245 30.3074 9.16744 29.1747 7.14805 27.4499C5.12865 25.7252 3.62554 23.4756 2.80488 20.9499"
            stroke="#FF5943"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : width === 24 ? (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 1.7002C13.9182 1.7002 15.3226 1.97955 16.6329 2.5223C17.9432 3.06505 19.1338 3.86057 20.1367 4.86344C21.1396 5.86632 21.9351 7.0569 22.4779 8.36722C23.0206 9.67753 23.3 11.0819 23.3 12.5002C23.3 13.9185 23.0206 15.3229 22.4778 16.6332C21.9351 17.9435 21.1396 19.1341 20.1367 20.137C19.1338 21.1398 17.9432 21.9353 16.6329 22.4781C15.3226 23.0208 13.9182 23.3002 12.4999 23.3002C11.0817 23.3002 9.67728 23.0208 8.36697 22.4781C7.05665 21.9353 5.86607 21.1398 4.86319 20.1369C3.86032 19.1341 3.0648 17.9435 2.52205 16.6332C1.9793 15.3229 1.69995 13.9185 1.69995 12.5002C1.69995 11.0819 1.9793 9.67753 2.52205 8.36721C3.06481 7.05689 3.86033 5.86631 4.8632 4.86344C5.86608 3.86057 7.05666 3.06504 8.36698 2.52229C9.67729 1.97954 11.0817 1.70019 12.5 1.7002L12.5 1.7002Z"
            stroke="#D1D5DB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.5 1.7002C14.4917 1.7002 16.4447 2.25099 18.1429 3.29168C19.8412 4.33237 21.2186 5.82243 22.1228 7.5971C23.0271 9.37177 23.4229 11.3619 23.2667 13.3476C23.1104 15.3332 22.4081 17.2369 21.2373 18.8483C20.0666 20.4596 18.4731 21.7159 16.6329 22.4781C14.7928 23.2403 12.7777 23.4788 10.8105 23.1672C8.84322 22.8556 7.00046 22.0061 5.48591 20.7126C3.97137 19.419 2.84403 17.7319 2.22854 15.8376"
            stroke="#FF5943"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 1.5C11.6819 1.5 12.8522 1.73279 13.9442 2.18508C15.0361 2.63738 16.0282 3.30031 16.864 4.13604C17.6997 4.97177 18.3626 5.96392 18.8149 7.05585C19.2672 8.14778 19.5 9.3181 19.5 10.5C19.5 11.6819 19.2672 12.8522 18.8149 13.9442C18.3626 15.0361 17.6997 16.0282 16.864 16.864C16.0282 17.6997 15.0361 18.3626 13.9441 18.8149C12.8522 19.2672 11.6819 19.5 10.5 19.5C9.3181 19.5 8.14778 19.2672 7.05585 18.8149C5.96392 18.3626 4.97176 17.6997 4.13604 16.864C3.30031 16.0282 2.63737 15.0361 2.18508 13.9441C1.73279 12.8522 1.5 11.6819 1.5 10.5C1.5 9.3181 1.73279 8.14777 2.18509 7.05584C2.63738 5.96391 3.30031 4.97176 4.13604 4.13604C4.97177 3.30031 5.96392 2.63737 7.05585 2.18508C8.14778 1.73279 9.31811 1.5 10.5 1.5L10.5 1.5Z"
            stroke="#D1D5DB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 1.5C12.1598 1.5 13.7873 1.95899 15.2025 2.82624C16.6177 3.69348 17.7655 4.93519 18.5191 6.41409C19.2726 7.89298 19.6025 9.55145 19.4723 11.2061C19.342 12.8608 18.7568 14.4473 17.7812 15.7901C16.8055 17.1329 15.4776 18.1797 13.9442 18.8149C12.4107 19.4501 10.7315 19.6488 9.09209 19.3892C7.45272 19.1295 5.91709 18.4216 4.65497 17.3437C3.39285 16.2657 2.4534 14.8597 1.94049 13.2812"
            stroke="#FF5943"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </OuterDiv>
  );
};

export default Loader;
